import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { Button } from "@ui/Button";
import { cn } from "@/utils/tailwind";

interface SectionFetchErrorProps {
  refetch: () => void;
  className?: string;
  message?: string;
}

const SectionFetchError: FC<SectionFetchErrorProps> = ({ refetch, className, message }) => {
  const { t } = useTranslation();

  return (
    <section
      className={cn("flex h-full w-full flex-col items-center justify-center gap-4 p-4", className)}
      data-test="section-fetch-error"
    >
      <AlertTriangle className="text-primary size-12" strokeWidth={1.5} />
      <p className="mb-4 text-center whitespace-pre-line">{message ?? t("fetchErrorMessage")}</p>
      <Button onClick={refetch} data-test="retry-button">
        {t("refresh")}
      </Button>
    </section>
  );
};

export default SectionFetchError;
